import React from 'react';
import { Typography, Avatar, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  user_container: {
    display: 'flex',
  },
  content: {
    flex: 1,
    margin: '0 10px',
  },
  avatar: {
    color: '#fff',
  },
}));

export default function UserWithStatus({ name, color }) {
  const classes = useStyles();
  return (
    <div className={classes.user_container}>
      <div>
        <Avatar className={classes.avatar} style={{ backgroundColor: color }}>
          {name[0].toUpperCase()}
        </Avatar>
      </div>
      <div className={classes.content}>
        <Typography variant='body1'>{name}</Typography>
        <Typography variant='body2' color='textSecondary'>
          Online
        </Typography>
      </div>
    </div>
  );
}
